import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { users } from '../api';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await users.forgotPassword(email);
      setSent(true);
    } catch {
      setError('Anfrage fehlgeschlagen. Bitte später erneut versuchen.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm">
        <img src="/juni-logo.svg" alt="juni" className="h-8 mx-auto mb-8" />
        <div className="bg-surface border border-slate-200 rounded-xl shadow-sm p-6">
          {sent ? (
            <div className="text-center py-4">
              <CheckCircle className="mx-auto text-brand-600 mb-3" size={40} />
              <h1 className="text-lg font-semibold text-slate-900 mb-1">{t('auth.emailSent')}</h1>
              <p className="text-sm text-slate-500 mb-5">
                Falls ein aktives Konto mit dieser Adresse existiert, haben wir einen Link zum
                Zurücksetzen verschickt.
              </p>
              <Link
                to="/login"
                className="inline-block bg-brand-600 hover:bg-brand-700 text-white font-medium text-sm px-4 py-2 rounded-lg"
              >
                Zurück zur Anmeldung
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-lg font-semibold text-slate-900 mb-1">{t('auth.forgotPassword')}</h1>
              <p className="text-sm text-slate-500 mb-5">
                Wir schicken Ihnen einen Link zum Zurücksetzen an Ihre dienstliche Adresse.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                {error && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm">
                    {error}
                  </div>
                )}
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">E-Mail</label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-brand-600 hover:bg-brand-700 text-white font-medium text-sm py-2.5 rounded-lg transition-colors disabled:opacity-60"
                >
                  {loading ? 'Wird gesendet…' : 'Link anfordern'}
                </button>
              </form>
              <p className="text-sm text-slate-500 mt-4 text-center">
                <Link to="/login" className="text-brand-600 hover:text-brand-800">
                  Zurück zur Anmeldung
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
